import type { Message } from '../types';

type RawMessage = Omit<Message, 'createdAt' | 'readAt' | 'id'> & {
  id?: unknown;
  createdAt?: unknown;
  readAt?: unknown;
};

const toValidDate = (value: unknown): Date | null => {
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === 'string' || typeof value === 'number') {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  return null;
};

const buildFallbackId = (message: RawMessage, createdAt: Date): string => {
  const conversationId =
    typeof message.conversationId === 'string' && message.conversationId.length > 0
      ? message.conversationId
      : 'unknown-conversation';

  const senderId =
    typeof message.senderId === 'string' && message.senderId.length > 0 ? message.senderId : 'unknown-sender';

  const content =
    typeof message.content === 'string' && message.content.length > 0 ? message.content : 'unknown-content';

  return `temp:${conversationId}:${senderId}:${createdAt.getTime()}:${content}`;
};

export const normalizeMessage = (message: RawMessage): Message => {
  const createdAt = toValidDate(message.createdAt) ?? new Date();
  const readAt = toValidDate(message.readAt);

  const id =
    typeof message.id === 'string' && message.id.trim().length > 0
      ? message.id
      : buildFallbackId(message, createdAt);

  return {
    ...(message as Omit<Message, 'createdAt' | 'readAt' | 'id'>),
    id,
    createdAt,
    readAt: readAt ?? null,
  };
};

